window.$ = window.jQuery = require("jquery");

require("~/sentry-init");
require("~/amplitude-init");
import "rangeslider.js";
require("../../../node_modules/polyfill-array-includes/index.js");
require("../js/external-scripts/numeric");
require("../js/external-scripts/rangeslider.min");
require("../js/external-scripts/matchmedia");
// require('../js/external-scripts/bootstrap-datepicker');
